import React from 'react'
import { useIsEligibleForInstall } from '../../../../lib/hooks/install-eligibility'
import { NotAvailableButton } from '../unsupported/not-available-button'
import { KeyboardInstallButtonBase, KeyboardInstallButtonBaseProps } from './base'

export type DeviceSpecificKeyboardInstallButtonBaseProps = KeyboardInstallButtonBaseProps

export const DeviceSpecificKeyboardInstallButtonBase: React.FC<DeviceSpecificKeyboardInstallButtonBaseProps> = (
  props
) => {
  const isCorrectDevice = useIsEligibleForInstall(props.install)

  return isCorrectDevice ? <KeyboardInstallButtonBase {...props} /> : <NotAvailableButton {...props} />
}
